/* WOW Anfrage-Kopie fürs Dashboard (live 02.11.2026, v2).
   Jedes abgeschickte Shopify-Kontaktformular schickt zusätzlich eine Kopie per sendBeacon an /api/anfrage.
   v2: Shopifys Spam-Schutz fängt das Absenden ab (preventDefault) und schickt das Formular später selbst ab –
   deshalb horchen wir in der Capture-Phase und lesen die Felder einen Takt später, nachdem die Theme-Skripte
   die versteckten Felder (Zeitraum, Preis …) gefüllt haben. Die Mail bleibt unverändert. */
(function () {
  if (window.__wowAnfLog) return; window.__wowAnfLog = 2;
  var API = 'https://wow-alarm.vercel.app/api/anfrage';
  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function send(form) {
    try {
      if (form.__wowSent && Date.now() - form.__wowSent < 15000) return;
      if (form.checkValidity && !form.checkValidity()) return;
      var f = {}, n = 0;
      Array.prototype.forEach.call(form.elements, function (el) {
        var k = el.name || '', mm = k.match(/^contact\[(.+)\]$/);
        if (!mm || el.disabled) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        var v = String(el.value || '').trim();
        if (!v || n > 60) return;
        n++; f[mm[1]] = f[mm[1]] ? f[mm[1]] + ', ' + v : v;
      });
      if (!f.email && !f.phone) return;
      if (f.Finca && 'Anreise' in f === false && /wowa-form/.test(form.getAttribute('action') || '')) return;
      form.__wowSent = Date.now();
      var data = JSON.stringify({ f: f, u: location.href.split('#')[0].slice(0, 500), h: handle(), l: (document.documentElement.lang || '').slice(0, 5), t: document.title.slice(0, 200) });
      var blob = new Blob([data], { type: 'text/plain' });
      if (!(navigator.sendBeacon && navigator.sendBeacon(API, blob))) {
        fetch(API, { method: 'POST', body: data, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'no-cors', credentials: 'omit' }).catch(function () {});
      }
    } catch (x) { /* Kopie ist optional */ }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var ft = form.querySelector('input[name="form_type"]');
    if (!ft || ft.value !== 'contact') return;
    setTimeout(function () { send(form); }, 0);
  }, true);
})();
